import { CalendarDays, MapPin } from "lucide-react";
import { Sections, usePage } from "../../hooks/usePage";
import { useSite } from "../../context/SiteContext";
import { Loading, PageHero, RichText, SectionHeading } from "../../components/site/Blocks";
import { mediaSrc } from "../../lib/api";
import { formatEventDate } from "../../lib/format";

const Details = ({ data }) => {
  const { event } = useSite();
  return (
    <>
      <PageHero eyebrow={data.eyebrow} title={data.heading} image={data.image_url} testid="venue-hero" />
      <section className="py-16" data-testid="venue-details">
        <div className="container-site grid gap-12 lg:grid-cols-2">
          <div>
            <RichText html={data.body} />
            <div className="mt-6 space-y-3 rounded-lg bg-paleblue p-6" data-testid="venue-event-card">
              <p className="flex gap-3 text-navy"><MapPin className="text-burgundy" aria-hidden="true" />
                <span><b>{event.venue_name || "Venue to be confirmed"}</b><br />{event.venue_address}{event.venue_address && <br />}{event.venue_city}</span></p>
              <p className="flex gap-3 text-navy"><CalendarDays className="text-burgundy" aria-hidden="true" />{formatEventDate(event)}{!event.date_confirmed && " (to be confirmed)"}</p>
            </div>
          </div>
          {data.map_embed_url ? <iframe title="Venue map" src={data.map_embed_url} className="h-80 w-full rounded-lg border-0" loading="lazy" />
            : data.image_url && <img src={mediaSrc(data.image_url)} alt={data.image_alt || ""} className="aspect-[4/3] w-full rounded-lg object-cover" />}
        </div>
      </section>
    </>
  );
};

const Travel = ({ data }) => (
  <section className="bg-sand py-16" data-testid="venue-travel">
    <div className="container-site max-w-4xl"><SectionHeading title={data.heading} /><RichText html={data.body} className="mt-5" /></div>
  </section>
);

export default function Venue() {
  const { page, loading } = usePage("venue");
  if (loading) return <Loading />;
  return <div data-testid="venue-page"><Sections page={page} render={{ details: Details, travel: Travel }} /></div>;
}
